// extracted by mini-css-extract-plugin
module.exports = {"numberBox":"numberBox_numberBox__hOi09"};